export default __webpack_public_path__ + "static/media/FM.ad27ac5e.svg";